import { createAction } from 'redux-act';

export interface AnnouncementAcknowledgedPayload {
  uuid: string;
}
export const announcementAcknowledged = createAction<AnnouncementAcknowledgedPayload>('ANNOUNCEMENT_ACKNOWLEDGED');
